import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TpolService, PageBusquedaObject, CtbTpolCatalogoDto } from '../ctb-tpol.service';
import { LoginService } from '../../../login/login.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-ctb-tpol',
  templateUrl: './catalogo-ctb-tpol.component.html',
  styleUrls: ['./catalogo-ctb-tpol.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [TpolService],
  preserveWhitespaces: true
})
export class CatalogoCtbTpolComponent implements OnInit {
  busqueda: PageBusquedaObject = new PageBusquedaObject();
  totalItems: number;
  rotate: any;
  items: CtbTpolCatalogoDto[];
  cargado: boolean;
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  constructor(public loginService: LoginService, private router: Router, private tpolService: TpolService) {
    this.busqueda.criteriaSearch = {};
    this.busqueda.itemsPerPage = 10;
    this.busqueda.pageNumber = 0;
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ngOnInit() {
    this.cargarCatalogo();
  }

  cargarCatalogo() {
    this.mostrarMensajeCarga();
    // this.busqueda.criteriaSearch['suc'] = this.loginService.sucursal;
    this.busqueda.criteriaSearch['emp'] = this.loginService.empresa;
    this.tpolService.tpolCatalogo(this.busqueda).subscribe(response => {
      this.items = response.contenido.content;
      this.totalItems = response.contenido.totalElements;
      this.cerrarMensajeCarga();
    }, err => {
      this.cerrarMensajeCarga();
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'Mensaje',
        text: err.error.mensaje
      })
      console.log(err);
    });
  }
  cambiarPagina(event: any): void {
    this.busqueda.pageNumber = event.page - 1;
    this.cargarCatalogo();
  }
  filtroDeBusqueda(find: any, columnName: any): void {
    this.busqueda.criteriaSearch[columnName] = find;
  }
  sortearPor(columnName: any): void {
    this.busqueda.column = columnName;
    this.busqueda.sort = true;
    this.busqueda.pageNumber = 0;
    switch (this.busqueda.order) {
      case 'desc':
        this.busqueda.order = 'asc';
        break;
      default:
        this.busqueda.order = 'desc';
        break;
    }
    this.cargarCatalogo();
  }
  buscarEnCatalogo(): void {
    this.busqueda.pageNumber = 0;
    this.cargarCatalogo();
  }
  limpiarBusqueda(): void {
    this.busqueda.criteriaSearch = {};
    this.cargarCatalogo();
  }
  eliminar(dtoEliminar: CtbTpolCatalogoDto): void {
    Swal.fire({
      title: 'Atención',
      text: `¿Está seguro de dar de baja este elemento?`,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Aceptar'
    }).then((result) => {
      if (result.value) {
        this.tpolService.tpolDelete(dtoEliminar.id, this.loginService.usuario.id as number).subscribe(response => {
          Swal.fire('Mensaje', response.mensaje, 'success');
          this.buscarEnCatalogo();
        }, err => {
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire('Mensaje', err.error.mensaje, 'error');
        });
      }
    });
  }
  mostrarMensajeCarga() {
    this.cargado = false;
    Swal.fire({
      title: 'Mensaje',
      html: 'Procesando...',
      timerProgressBar: true,
      showConfirmButton: false,
allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading()
      }
    });
  }
  cerrarMensajeCarga() {
    this.cargado = true;
    Swal.close();
  }
}
